import React, { memo, ReactNode } from 'react';

import Typography from '../../library/typography/typography';
import {
  CircleCheckSolidIcon,
  CircleXmarkSolidIcon
} from '../../shared/icons/icons';

import './product-availability-message.one-dt.scss';

interface ProductAvailabilityMessageProps {
  availabilityMessage: string;
  availabilityMessageRank?: number;
  className?: string;
  hideIcons?: boolean;
  hideSuffix?: boolean;
  iconAvailable?: ReactNode;
}

function ProductAvailabilityMessage(props: ProductAvailabilityMessageProps) {
  const {
    availabilityMessage,
    availabilityMessageRank,
    className,
    hideIcons = false,
    hideSuffix = false,
    iconAvailable
  } = props;

  return (
    <Typography
      className={`${className || ''} product-availability-message`}
      data-testid="product-availability-message"
      styleName="container"
      tag="span"
    >
      {!hideIcons && (
        <>
          {Number(availabilityMessageRank) > 5 ? (
            <CircleXmarkSolidIcon
              className="product-availability-message__icon"
              styleName="icon-unavailable"
            />
          ) : (
            <>
              {iconAvailable ? (
                iconAvailable
              ) : (
                <CircleCheckSolidIcon
                  className="product-availability-message__icon"
                  styleName="icon"
                />
              )}
            </>
          )}
        </>
      )}
      <span>
        {availabilityMessage?.replace(' at My Store', '')}
        {!hideSuffix ? ' at ' : ''}
      </span>
    </Typography>
  );
}

export default memo(ProductAvailabilityMessage);
